module.exports = __webpack_public_path__ + "img/76800.f52ac568.jpg";